import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BorderedCheckbox } from '@repo/ui';
import VehicleNameDisplay from './VehicleNameDisplay';
import VehicleRegistrationDisplay from './VehicleRegistrationDisplay';
export default function VehicleCheckboxGroup({ testId, vehicles, value, onChange, disabled, maxSelected, minSelected, maxHeight, className, }) {
    const isScrollable = maxHeight !== undefined;
    const isAtMax = maxSelected !== undefined && value.length >= maxSelected;
    const isAtMin = minSelected !== undefined && value.length <= minSelected;
    const handleToggle = (vehicleId, checked) => {
        if (!onChange)
            return;
        if (checked) {
            onChange([...value, vehicleId]);
        }
        else {
            onChange(value.filter((id) => id !== vehicleId));
        }
    };
    return (_jsx("div", { className: className, children: _jsx("div", { className: isScrollable ? 'flex flex-col gap-2 overflow-y-auto p-0.5' : 'flex flex-col gap-2', style: isScrollable ? { maxHeight } : undefined, children: vehicles.map((vehicle) => {
                const itemTestId = testId.append('option').append(vehicle.id);
                const checked = value.includes(vehicle.id);
                const isLocked = checked ? isAtMin : isAtMax;
                return (_jsx(BorderedCheckbox, { testId: itemTestId, checked: checked, disabled: disabled || isLocked, onChange: (next) => handleToggle(vehicle.id, next), label: _jsxs("div", { className: "flex flex-row items-center gap-2", children: [_jsx(VehicleRegistrationDisplay, { registrationNumber: vehicle.registrationNumber, testId: itemTestId.append('registration') }), vehicle.name && _jsx(VehicleNameDisplay, { vehicle: vehicle, testId: itemTestId.append('name') })] }) }, vehicle.id));
            }) }) }));
}
